import { useEffect, useState } from 'react';

import { createCustomContext } from '@utils';

import { transactionsActions, useStore } from '@modules';
import { CryptoCurrencyEnum } from '@modules/global/types';

export const { useCustomContext, withCustomProvider } = createCustomContext(() => {
  const [{ user }, dispatch] = useStore();
  const [currency, setCurrency] = useState<CryptoCurrencyEnum>(CONST.defaultCryptoCurrency);

  const languageCode = user.data?.language_code;

  useEffect(() => {
    dispatch(transactionsActions.getReferral(currency));
    dispatch(transactionsActions.getReferralTransactions({ currency }));
    return () => {
      dispatch(transactionsActions.resetReferralList());
    };
  }, [currency]);

  return {
    currency,
    setCurrency,
    languageCode,
  };
});
